import React, { Component } from 'react';
import logo from "../images/jamie_64px.jpg";
import "./message.css";
import classNames from "classnames";

class Message extends Component {
  render() {
    const containerClasses = classNames(
      'message-container', 
      { 
        'system': this.props.system, 
        'user': !this.props.system, 
        'animate': !this.props.animation.entered,
      }, 
      this.props.className)
    const boxClasses = classNames(
      'message-box', this.props.className, 
      { 
        'has-avatar': this.props.avatar, 
        'no-padding': this.props.noPadding,
        'small-margin': this.props.smallMargin,
      })

    return (
      <div id={this.props.id} className={containerClasses}>
        { this.props.avatar && <img src={logo} alt="avatar" className="message-avatar"/>}
        <div className={boxClasses}>
          { !this.props.animation.entering && this.props.children }
          { this.props.system && this.props.animation.entering && 
            <div className="message-loading-container">
              <div className="message-loading-dot dot1">
              </div>
              <div className="message-loading-dot dot2">
              </div>
              <div className="message-loading-dot dot3">
              </div>
            </div>
          }
          
        </div>
      </div>
    )
  }
}

export default Message;


// WEBPACK FOOTER //
// ./src/components/message.js